import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpCheckConversion
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * For the check pages before submission an overview of the selected conversion options is shown.
     * This directive can be used for that.
     *
     * @param {boolean?} [unbundledToBundled=false] Whether this is a unbundled to bundled conversion. By default this is for
     *  capacity upgrade.
     * @param {app.CapacityUpgradeDto[]|app.FirmCapacityUpgradeDto[]} conversions
     * @param {Object} networkPoint
     *
     * @attr {PkpUseOriginals} pkpUseOriginals
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpCheckConversion', pkpCheckConversion);

    function pkpCheckConversion(fieldKeyService) {
        return {
            restrict: 'E',
            scope: {
                conversions: '=',
                networkPoint: '='
            },
            template: require('app/conversion/pkp-check-conversion.directive.html'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, DATES) {
            scope.DATES = DATES;
            scope.fieldKey = fieldKeyService.initialize(attr.pkpUseOriginals);
            scope.unbundledToBundled =
                scope.$eval(attr.unbundledToBundled) === true;
        }
    }
})();
